import React, { Fragment } from "react";
import Head from "layout/Head";

import { BRAND_PRINCIPLES_CONFIG } from "./Landing.config";
import { BrandTrust } from "pages/LayoutComponents/BrandTrust/BrandTrust";
import { OverviewBrandPrinciples } from "components/OverviewBrandPrinciples";
import { useTranslation } from "hooks/useTranslation";
import { StyledContainer } from "components/StyledContainer";
import { CaseStudyBlock } from "../CloudGateways/EnterpriseScale/_components/CaseStudyBlock";
import { HologramTour } from "./_components/HologramTour";
import { InView } from "react-intersection-observer";

export const Landing = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Head
        title={t("landing.seo.title")}
        description={t("landing.seo.description")}
        url="https://ui.com/"
        image="https://www.ui.com/microsite/og-image.homepage.jpg"
      />

      <Fragment>
        <InView
          as="div"
          threshold={0.1}
          initialInView
          trackVisibility
          delay={100}
        >
          {({ inView, ref }) => (
            <div ref={ref}>
              <HologramTour isInView={inView} />
            </div>
          )}
        </InView>

        <InView as="div" threshold={0.3} trackVisibility delay={100}>
          {({ inView, ref }) => (
            <div ref={ref}>
              <OverviewBrandPrinciples
                items={BRAND_PRINCIPLES_CONFIG}
                title={t("brandPrinciples.title")}
                isInView={inView}
              />
            </div>
          )}
        </InView>

        <StyledContainer
          size="desktop"
          noVerticalMargin
          $spacing={{ top: 72, bottom: 72 }}
        >
          <BrandTrust />
        </StyledContainer>

        <InView as="div" threshold={0.3} trackVisibility delay={100}>
          {({ inView, ref }) => (
            <div ref={ref}>
              <CaseStudyBlock isAlignLeft isInView={inView} />
            </div>
          )}
        </InView>
      </Fragment>
    </Fragment>
  );
};
